import React from 'react';
import LaEligibility from './LaEligibility';
import LaQuestions from './LaQuestions';
import LaSummary from './LaSummary';
import {
    emptyAnswers,
    fromApplication,
    getEligibilityErrors,
    getErrors,
    getQuestionErrors,
    toPayload,
} from './laAnswers';
import './programs.css';

const laProgram = {
    key: 'la',
    roleName: 'Learning Assistant',
    article: 'a',
    label: 'LA',
    full: 'Learning Assistant',
    bg: '',
    badgeClassName: 'program-badge-la',
    description:
        'Support active learning in STEM courses by facilitating in-class group work, helping students during activities, and bridging the gap between instructor and student perspectives.',
    noteVariant: 'info',
    note: (
        <>
            <strong>Learning Assistant:</strong> You will support active
            learning in STEM courses by facilitating in-class activities and
            group work.
        </>
    ),
    steps: [
        { label: 'Choose Program', blocks: ['program'] },
        { label: 'About You', blocks: ['aboutYou'] },
        {
            label: 'Eligibility',
            blocks: ['eligibility', 'campusEmployment', 'programEligibility'],
        },
        {
            label: 'Positions',
            blocks: [
                'positions',
                'requirementAnswers',
                'positionCommitments',
                'generalPool',
            ],
        },
        {
            label: 'Learning Assistant Questions',
            blocks: ['programQuestions', 'resume'],
        },
        { label: 'Review & Submit', blocks: ['review'] },
    ],
    EligibilityQuestions: LaEligibility,
    Questions: LaQuestions,
    Summary: LaSummary,
    emptyAnswers,
    fromApplication,
    toPayload,
    getErrors,
    getEligibilityErrors,
    getQuestionErrors,
};

export default laProgram;
